<template>
    <el-col :xs="{span:24}" :md="width" v-show="show"> 
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-button type="primary" :disabled="disabled" >签名</el-button>
            <!-- <el-image-viewer
                :src="data[name]"
                :preview-src-list="previewUrls"
                class="signImage">
            </el-image-viewer> -->
        </el-form-item>
    </el-col>
</template>

<script>
    import BaseSignField from "./BaseSignField"

    export default {
        name:"SignField",
        mixins:[BaseSignField]
    }
</script>